import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ResourceTypeLink } from "@evergis/api";

import { CheckboxDescription, TextLine } from "../../DeleteLayer/styled";
import { DeleteDescription } from "../styled";
import { UsersTooltip } from "../../DeleteLayer/UsersTooltip";
import { ResourcesTooltip } from "./ResourcesTooltip";
import { getUsername } from "../../../../ducks/user";
import { userNamesWithAccess } from "./userNamesWithAccess";
import { useAdditionalParameters } from "../hooks/useAdditionalParameters";
import { DeleteContent } from "./DeleteContent";
import { ResourcesResolved } from "../resolveResources";
import { DeleteResourcesContentProps } from "../types";

type DeleteProjectsDescriptionProps = Pick<DeleteResourcesContentProps, "type" | "toggle" | "checked"> &
  ResourcesResolved;

export const DeleteProjectsDescription: FC<DeleteProjectsDescriptionProps> = ({
  type,
  projects,
  layers,
  tables,
  checked,
  toggle,
}) => {
  const { t } = useTranslation("dialogs");
  const { showMore, toggleButton } = useAdditionalParameters();

  const currentUser: string = useSelector(getUsername);
  const usersWithProjectAccessNames = useMemo(
    () => userNamesWithAccess(projects, currentUser, t("access.public")),
    [projects, currentUser, t],
  );

  const projectsCount = projects.length;

  if (!projects || projectsCount === 0) {
    return null;
  }

  return (
    <div>
      <div>
        {t("deleteResources.confirmDeletion")}{" "}
        {projectsCount === 1 ? (
          t("deleteResources.mapDeletion")
        ) : (
          <ResourcesTooltip resourceType={ResourceTypeLink.Project} resources={projects} />
        )}
        ?
      </div>
      {toggleButton}
      {showMore && (
        <>
          <DeleteContent
            type={type}
            layers={layers}
            tables={tables}
            projects={projects}
            checked={checked}
            toggle={toggle}
          />
          {usersWithProjectAccessNames.length >= 1 && (
            <DeleteDescription>
              <CheckboxDescription>
                <TextLine>
                  <span>
                    {t("deleteResources.usersWithAccess").replace(
                      "{resourceType}",
                      projectsCount > 1 ? t("deleteResources.toMaps") : t("deleteResources.toMap"),
                    )}
                    :&nbsp;
                  </span>
                  <UsersTooltip users={usersWithProjectAccessNames} />
                </TextLine>
                <TextLine>
                  <span>
                    {projectsCount > 1
                      ? t("deleteResources.unavailableMapsCatalog")
                      : t("deleteResources.unavailableMapCatalog")}
                  </span>
                </TextLine>
              </CheckboxDescription>
            </DeleteDescription>
          )}
        </>
      )}
    </div>
  );
};
